import { useMutation } from '@apollo/client/react';

import { EnergyQuoteType } from '@generated/gql/graphql';
import {
  deselectEnergyQuotes,
  selectEnergyQuotes,
} from '@utils/queries/energyQueries';

const useSelectEnergy = () => {
  const [selectQuotes, { loading, error, reset }] =
    useMutation(selectEnergyQuotes);

  return {
    selectQuotes: (basketId: string, quoteType: EnergyQuoteType) =>
      selectQuotes({
        variables: {
          input: {
            basketId,
            quoteType,
          },
        },
      }),
    loading,
    error,
    reset,
  };
};

const useDeselectEnergy = () => {
  const [deselectQuotes, { loading, error, reset }] =
    useMutation(deselectEnergyQuotes);

  return {
    deselectQuotes: (basketId: string) =>
      deselectQuotes({
        variables: { basketId },
      }),
    loading,
    error,
    reset,
  };
};

export { useSelectEnergy, useDeselectEnergy };
